import 'jquery.marquee';

if( $('.js-marquee').length > 0 ) {
  $('.js-marquee').marquee({
    duration: 32000,
    gap: 24,
    startVisible: true,
    duplicated: true,
    direction: 'left',
  });
}